import { createI18n } from 'vue-i18n';
import zhCNModules from '@/assets/languages/zh_CN';
const zhModules = require.context('./lang/zh-CN', true, /\.js$/);
const enModules = require.context('./lang/en-US', true, /\.js$/);

export const siphonI18n = (lang, prefix = 'zh-CN') => {
  const langsObj = {};
  lang.keys().forEach(item => {
    let fileName = item.replace(`./${prefix}/`, '').replace(/^\.\//, '');
    fileName = fileName.substring(0, fileName.lastIndexOf('.'));

    const keyList = fileName.split('/');
    const moduleName = keyList.shift();
    const objKey = keyList.join('.');
    const langFileModule = lang(item)?.['default'];
    if (moduleName) {
      if (objKey) {
        langsObj[moduleName] = langsObj[moduleName] || {};
        langsObj[moduleName][objKey] = langFileModule;
      } else {
        langsObj[moduleName] = langFileModule || {};
      }
    }
  });
  return langsObj;
};

export const i18n = createI18n({
  locale: 'en-US', // Cache value
  fallbackLocale: 'en-US',
  legacy: false,
  messages: {
    'zh-CN': {
      ...siphonI18n(zhModules, 'zh-CN'),
      ...zhCNModules
    },
    'en-US': {
      ...siphonI18n(enModules, 'en-US')
    }
  }
});

export function usI18n(app) {
  app.use(i18n);
}
